import type { IconData } from '@stacksjs/iconify-core'

export const th4x3: IconData = {
  "body": "<g fill-rule=\"evenodd\"><path fill=\"#f4f5f8\" d=\"M0 0h640v480H0z\"/><path fill=\"#2d2a4a\" d=\"M0 162.5h640v160H0z\"/><path fill=\"#a51931\" d=\"M0 0h640v82.5H0zm0 400h640v80H0z\"/></g>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default th4x3
